var _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlsxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_181_2558",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.1471 60H4.85294C2.17274 60 0 58.0812 0 55.7143V4.28572C0 1.91878 2.17274 0 4.85294 0H37.5L60 19.8701V55.7143C60 58.0812 57.8273 60 55.1471 60Z",
    fill: "url(#paint0_linear_181_2558)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_181_2558)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1471 60H4.85294C2.17274 60 0 58.0812 0 55.7143V4.28572C0 1.91878 2.17274 0 4.85294 0H37.5L60 19.8701V55.7143C60 58.0812 57.8273 60 55.1471 60Z",
    fill: "url(#paint1_linear_181_2558)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.82,
    filter: "url(#filter0_f_181_2558)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5879,
    y: 29.0264,
    width: 39.2647,
    height: 16.3636,
    fill: "#0F7D56",
    fillOpacity: 0.27,
    style: {
      mixBlendMode: "darken"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_181_2558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 19.8701H57.3701C46.3962 19.8701 37.5 10.974 37.5 0L60 19.8701Z",
    fill: "url(#paint2_linear_181_2558)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6364 30.4545L17.8395 35.7812H17.9531L21.1705 30.4545H24.1747L19.6932 37.7273L24.2457 45H21.1918L17.9531 39.7088H17.8395L14.6009 45H11.5611L16.1562 37.7273L11.6179 30.4545H14.6364ZM26.2433 45V30.4545H28.8782V42.7912H35.2844V45H26.2433ZM45.4762 34.4531C45.4099 33.8329 45.1306 33.3499 44.6381 33.0043C44.1505 32.6586 43.516 32.4858 42.7347 32.4858C42.1855 32.4858 41.7144 32.5687 41.3214 32.7344C40.9284 32.9001 40.6277 33.125 40.4194 33.4091C40.2111 33.6932 40.1045 34.0175 40.0998 34.3821C40.0998 34.6851 40.1684 34.9479 40.3058 35.1705C40.4478 35.393 40.6396 35.5824 40.881 35.7386C41.1225 35.8902 41.39 36.018 41.6836 36.1222C41.9772 36.2263 42.2731 36.3139 42.5714 36.3849L43.935 36.7259C44.4843 36.8537 45.0122 37.0265 45.5188 37.2443C46.0302 37.4621 46.4871 37.7367 46.8896 38.0682C47.2968 38.3996 47.6187 38.7997 47.8555 39.2685C48.0922 39.7372 48.2106 40.2865 48.2106 40.9162C48.2106 41.7685 47.9928 42.5189 47.5572 43.1676C47.1216 43.8116 46.4918 44.3158 45.668 44.6804C44.8488 45.0402 43.8569 45.2202 42.6921 45.2202C41.5605 45.2202 40.578 45.045 39.7447 44.6946C38.9161 44.3442 38.2674 43.8329 37.7987 43.1605C37.3346 42.4882 37.0837 41.669 37.0458 40.7031H39.6381C39.676 41.2098 39.8323 41.6312 40.1069 41.9673C40.3815 42.3035 40.739 42.5545 41.1793 42.7202C41.6244 42.8859 42.1216 42.9688 42.6708 42.9688C43.2437 42.9688 43.7456 42.8835 44.1765 42.7131C44.6121 42.5379 44.953 42.2964 45.1992 41.9886C45.4454 41.6761 45.5709 41.3116 45.5756 40.8949C45.5709 40.5161 45.4596 40.2036 45.2418 39.9574C45.024 39.7064 44.7186 39.4981 44.3256 39.3324C43.9374 39.1619 43.4828 39.0104 42.962 38.8778L41.3072 38.4517C40.1093 38.1439 39.1623 37.6776 38.4663 37.0526C37.775 36.4228 37.4293 35.5871 37.4293 34.5455C37.4293 33.6884 37.6613 32.938 38.1254 32.294C38.5941 31.6501 39.2309 31.1506 40.0359 30.7955C40.8408 30.4356 41.7522 30.2557 42.7702 30.2557C43.8024 30.2557 44.7068 30.4356 45.4833 30.7955C46.2646 31.1506 46.8777 31.6454 47.3228 32.2798C47.7679 32.9096 47.9975 33.634 48.0117 34.4531H45.4762Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_181_2558",
    x: -28.4121,
    y: -9.97363,
    width: 117.265,
    height: 94.3633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_181_2558"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_181_2558",
    x: 14.5,
    y: -24,
    width: 72.5,
    height: 69.8701,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_181_2558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_181_2558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_181_2558",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_181_2558",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000265127,
    stopColor: "#83CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61A850"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_181_2558",
    x1: 48.75,
    y1: 0,
    x2: 48.75,
    y2: 19.8701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FAF43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E8312"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsxIcon);
export default __webpack_public_path__ + "static/media/xlsx-icon.539af502ce58ff0f6ba75080d6e2d882.svg";
export { ForwardRef as ReactComponent };